// extracted by mini-css-extract-plugin
module.exports = {"img-text-card-box":"eD","imgTextCardBox":"eD","text-box":"eE","textBox":"eE","remark-val":"eF","remarkVal":"eF"};